module.exports = __webpack_public_path__ + "static/img/all-logo.1f9812c5.jpg";